module.exports = "<a *ngIf=\"linkHref\"\n   href=\"{{linkHref}}\"\n   [ngClass]=\"{'spinning-wheel__active' : isActive}\"\n   class=\"btn btn-add-round btn-success\" type=\"button\">\n</a>\n\n<button *ngIf=\"!linkHref\"\n        [ngClass]=\"{'spinning-wheel__active' : isActive}\"\n        class=\"btn btn-add-round btn-success spinning-wheel spinning-wheel__display-after\"\n        type=\"button\">\n</button>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/add-round-btn/add-round-btn.html
// module id = ./web/modern/components/buttons/add-round-btn/add-round-btn.html
// module chunks = 0